import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { ProfessionType, SupplementInfoField, specArrCode } from '@/components/supplement-info-fields/types';

@Component({ name: 'Industry' })
export default class Industry extends Vue implements SupplementInfoField {
  @Prop()
  private value!: undefined | number;

  private industry: undefined | number | null = null;

  private options: OptionItem[] | null = [];

  private errorMsg = '';

  private async created() {
    if (this.value) {
      this.industry = this.value;
    }

    this.options = await DictApi.getIndustryTypes();
  }

  public onValidator(): boolean {
    if (this.industry === null || this.industry === undefined) {
      this.errorMsg = '请选择所属行业';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeIndustry(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  @Watch('value')
  private onValueChange(val: number | null | undefined) {
    this.industry = val;
  }

  // 自营B 场景，限定行业
  public changeOptions(propValue: string | number): void {
    /**
     * 职业和行业不匹配时，清空行业信息
     * 需求背景：http://wiki.hellobike.com/pages/viewpage.action?pageId=340307549
     */
    if (this.industry
      && (!((propValue === ProfessionType.AGRICULTURE && this.industry === 101)
      || (propValue === ProfessionType.TRANSPORT && specArrCode.indexOf(this.industry) >= 0))
      )) {
      this.industry = null;
    }

    // TODO:先前端写死下拉值，后续根据接口返回对应值
    // 若职业为“农、林、牧、渔水利生产人员”，则行业选项限定为“农、林、牧、渔业”；
    if (propValue === ProfessionType.AGRICULTURE) {
      this.options = [
        {
          code: 101,
          name: '农业/林业/畜牧业/渔业',
        },
      ];
      return;
    }

    if (propValue === ProfessionType.TRANSPORT) {
      this.options = [
        {
          code: 101,
          name: '农业/林业/畜牧业/渔业',
        },
        {
          code: 102,
          name: '采矿业',
        },
        {
          code: 103,
          name: '制造业',
        },
        {
          code: 104,
          name: '电力/热力/燃气/水生产/供应业',
        },
        {
          code: 105,
          name: '建筑业',
        },
        {
          code: 107,
          name: '交通运输/仓储业/邮政业',
        },
        {
          code: 109,
          name: '信息传输/软件/信息技术服务业',
        },
        {
          code: 111,
          name: '房地产业',
        },
        {
          code: 113,
          name: '科学研究/技术服务业',
        },
        {
          code: 114,
          name: '水利/环境/公共设施管理业',
        },
        {
          code: 115,
          name: '居民服务/修理/其他服务业',
        },
        {
          code: 117,
          name: '卫生/社会工作',
        },
        {
          code: 118,
          name: '文化/体育/娱乐业',
        },
      ];
    }
  }

  private render() {
    return (
      <Field
        label="所属行业"
        errorMessage={this.errorMsg}
      >
        <SelectInput
          ref="industryRef"
          v-model={this.industry}
          title="选择所属行业"
          placeholder="选择所属行业"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeIndustry}
        />
      </Field>
    );
  }
}
